module.exports = __webpack_public_path__ + "static/media/dish-empty-icon.193e2b02.png";